import React from 'react'
import MaterialSymbol from '../material-symbol'

const Videocam = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="videocam" {...props} />
))

Videocam.displayName = 'Videocam'

export default Videocam
